import ActionButton from '@/common/components/buttons/ActionButton';
import Input from '@/common/components/Input';
import PopUp from '@/common/components/PopUp';
import { Title } from '@/common/styles/Mails';
import styled from 'styled-components';

const FormWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding: 20px;
	align-items: start;
`;

const MailCategoryTestConfig = ({
	showTestConfig,
	setShowTestConfig,
	emailTestConfigRef,
	handleTest,
}) => {
	return (
		<PopUp setShow={setShowTestConfig}>
			<FormWrapper>
				<Title>Testing: {showTestConfig.name}</Title>
				<Input
					style={{ width: '100%' }}
					name='email'
					label='Email'
					inputRef={emailTestConfigRef}
					placeholder='Enter email'
				/>
				<ActionButton
					defaultText='Send test'
					style={{ alignSelf: 'end' }}
					onClick={handleTest}
				/>
			</FormWrapper>
		</PopUp>
	);
};

export default MailCategoryTestConfig;
